import { Box, Typography } from "@mui/material";
import React from "react";

type Props = {
  width?: string;
  height?: string;
};

// is there actual CORE logo?
const CoreLogo = ({ width, height }: Props) => {
  const backgroundStyles = {
    width: width || "48px",
    height: height || "48px",
    borderRadius: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const typographyStyles = {
    fontSize: "14px",
    color: "#fff",
    fontWeight: 700,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  const core = "CORE";

  return (
    <Box bgcolor="#351F65" sx={backgroundStyles}>
      <Typography sx={typographyStyles}>{core}</Typography>
    </Box>
  );
};

export default CoreLogo;
